import { BuildingId, DeviceConfig, DeviceConfigId, UtcTime } from 'shared/models';

export const Actions = {
    DEVICE_CONFIGS_REQUEST: 'DEVICE_CONFIGS_REQUEST',
    DEVICE_CONFIGS_SUCCESS: 'DEVICE_CONFIGS_SUCCESS',
    DEVICE_CONFIGS_FAILURE: 'DEVICE_CONFIGS_FAILURE',

    DEVICE_CONFIG_DELETED: 'DEVICE_CONFIG_DELETED',

    DEVICE_CONFIGS_RELOAD: 'DEVICE_CONFIGS_RELOAD',
};

const ONE_DAY = 24 * 60 * 60 * 1000;

export const deviceConfigsRequest = (buildingId: BuildingId, meta?: { nextFetch: UtcTime }) => ({
    type: Actions.DEVICE_CONFIGS_REQUEST,
    payload: buildingId,
    meta: meta || {
        nextFetch: Date.now() + ONE_DAY,
    },
});

export const deviceConfigsSuccess = (payload: DeviceConfig[], meta: { buildingId: BuildingId }) => ({
    type: Actions.DEVICE_CONFIGS_SUCCESS,
    payload,
    meta,
});

export const deviceConfigsFailure = (error: Error, meta: { buildingId: BuildingId }) => ({
    type: Actions.DEVICE_CONFIGS_FAILURE,
    payload: error,
    meta,
    error: true,
});

export const deviceConfigDeleted = (deviceConfigId: DeviceConfigId) => ({
    type: Actions.DEVICE_CONFIG_DELETED,
    payload: deviceConfigId,
});

export const deviceConfigsReload = (buildingId: BuildingId) => ({
    type: Actions.DEVICE_CONFIGS_RELOAD,
    payload: buildingId,
});
